export const stringCutter = ({ text, textLen = 25 }) => {
  return text?.slice(0, textLen);
};
